module.exports = __webpack_public_path__ + "img/tbw.36660c20.jpg";